module.exports = __webpack_public_path__ + "static/media/main12.1799fb90.jpeg";